module.exports = __webpack_public_path__ + "static/media/CHOPP_MENU-normal.646042cd.png";